/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/pipeline.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  ApiGetTemplateResponse,
  ApiListPipelineVersionsResponse,
  ApiListPipelinesResponse,
  ApiPipeline,
  ApiPipelineVersion,
  GoogleRpcStatus,
} from '../models/index';
import {
  ApiGetTemplateResponseFromJSON,
  ApiGetTemplateResponseToJSON,
  ApiListPipelineVersionsResponseFromJSON,
  ApiListPipelineVersionsResponseToJSON,
  ApiListPipelinesResponseFromJSON,
  ApiListPipelinesResponseToJSON,
  ApiPipelineFromJSON,
  ApiPipelineToJSON,
  ApiPipelineVersionFromJSON,
  ApiPipelineVersionToJSON,
  GoogleRpcStatusFromJSON,
  GoogleRpcStatusToJSON,
} from '../models/index';

export interface CreatePipelineRequest {
  pipeline: ApiPipeline;
}

export interface CreatePipelineVersionRequest {
  version: ApiPipelineVersion;
}

export interface DeletePipelineRequest {
  id: string;
}

export interface DeletePipelineVersionRequest {
  version_id: string;
}

export interface GetPipelineByNameRequest {
  namespace: string;
  name: string;
}

export interface GetPipelineRequest {
  id: string;
}

export interface GetPipelineVersionTemplateRequest {
  version_id: string;
}

export interface GetPipelineVersionRequest {
  version_id: string;
}

export interface GetTemplateRequest {
  id: string;
}

export interface ListPipelineVersionsRequest {
  resource_key_type?: ListPipelineVersionsV1ResourceKeyTypeEnum;
  resource_key_id?: string;
  page_size?: number;
  page_token?: string;
  sort_by?: string;
  filter?: string;
}

export interface ListPipelinesRequest {
  page_token?: string;
  page_size?: number;
  sort_by?: string;
  filter?: string;
  resource_reference_key_type?: ListPipelinesV1ResourceReferenceKeyTypeEnum;
  resource_reference_key_id?: string;
}

export interface UpdatePipelineDefaultVersionRequest {
  pipeline_id: string;
  version_id: string;
}

/**
 *
 */
export class PipelineServiceApi extends runtime.BaseAPI {
  /**
   * Creates a pipeline.
   */
  async createPipelineRaw(
    requestParameters: CreatePipelineRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiPipeline>> {
    if (requestParameters['pipeline'] == null) {
      throw new runtime.RequiredError(
        'pipeline',
        'Required parameter "pipeline" was null or undefined when calling createPipeline().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/pipelines`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ApiPipelineToJSON(requestParameters['pipeline']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ApiPipelineFromJSON(jsonValue));
  }

  /**
   * Creates a pipeline.
   */
  async createPipeline(
    pipeline: ApiPipeline,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiPipeline> {
    const response = await this.createPipelineRaw({ pipeline: pipeline }, initOverrides);
    return await response.value();
  }

  /**
   * Adds a pipeline version to the specified pipeline.
   */
  async createPipelineVersionRaw(
    requestParameters: CreatePipelineVersionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiPipelineVersion>> {
    if (requestParameters['version'] == null) {
      throw new runtime.RequiredError(
        'version',
        'Required parameter "version" was null or undefined when calling createPipelineVersion().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/pipeline_versions`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ApiPipelineVersionToJSON(requestParameters['version']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiPipelineVersionFromJSON(jsonValue),
    );
  }

  /**
   * Adds a pipeline version to the specified pipeline.
   */
  async createPipelineVersion(
    version: ApiPipelineVersion,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiPipelineVersion> {
    const response = await this.createPipelineVersionRaw({ version: version }, initOverrides);
    return await response.value();
  }

  /**
   * Deletes a pipeline and its pipeline versions.
   */
  async deletePipelineRaw(
    requestParameters: DeletePipelineRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling deletePipeline().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/pipelines/{id}`;
    urlPath = urlPath.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id'])));

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Deletes a pipeline and its pipeline versions.
   */
  async deletePipeline(
    id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.deletePipelineRaw({ id: id }, initOverrides);
    return await response.value();
  }

  /**
   * Deletes a pipeline version by pipeline version ID. If the deleted pipeline version is the default pipeline version, the pipeline\'s default version changes to the pipeline\'s most recent pipeline version. If there are no remaining pipeline versions, the pipeline will have no default version. Examines the run_service_api.ipynb notebook to learn more about creating a run using a pipeline version (https://github.com/kubeflow/pipelines/blob/master/tools/benchmarks/run_service_api.ipynb).
   */
  async deletePipelineVersionRaw(
    requestParameters: DeletePipelineVersionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['version_id'] == null) {
      throw new runtime.RequiredError(
        'version_id',
        'Required parameter "version_id" was null or undefined when calling deletePipelineVersion().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/pipeline_versions/{version_id}`;
    urlPath = urlPath.replace(
      `{${'version_id'}}`,
      encodeURIComponent(String(requestParameters['version_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Deletes a pipeline version by pipeline version ID. If the deleted pipeline version is the default pipeline version, the pipeline\'s default version changes to the pipeline\'s most recent pipeline version. If there are no remaining pipeline versions, the pipeline will have no default version. Examines the run_service_api.ipynb notebook to learn more about creating a run using a pipeline version (https://github.com/kubeflow/pipelines/blob/master/tools/benchmarks/run_service_api.ipynb).
   */
  async deletePipelineVersion(
    version_id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.deletePipelineVersionRaw({ version_id: version_id }, initOverrides);
    return await response.value();
  }

  /**
   * Finds a pipeline by Name (and namespace)
   */
  async getPipelineByNameRaw(
    requestParameters: GetPipelineByNameRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiPipeline>> {
    if (requestParameters['namespace'] == null) {
      throw new runtime.RequiredError(
        'namespace',
        'Required parameter "namespace" was null or undefined when calling getPipelineByName().',
      );
    }

    if (requestParameters['name'] == null) {
      throw new runtime.RequiredError(
        'name',
        'Required parameter "name" was null or undefined when calling getPipelineByName().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/namespaces/{namespace}/pipelines/{name}`;
    urlPath = urlPath.replace(
      `{${'namespace'}}`,
      encodeURIComponent(String(requestParameters['namespace'])),
    );
    urlPath = urlPath.replace(`{${'name'}}`, encodeURIComponent(String(requestParameters['name'])));

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ApiPipelineFromJSON(jsonValue));
  }

  /**
   * Finds a pipeline by Name (and namespace)
   */
  async getPipelineByName(
    namespace: string,
    name: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiPipeline> {
    const response = await this.getPipelineByNameRaw(
      { namespace: namespace, name: name },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Finds a specific pipeline by ID.
   */
  async getPipelineRaw(
    requestParameters: GetPipelineRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiPipeline>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling getPipeline().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/pipelines/{id}`;
    urlPath = urlPath.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id'])));

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ApiPipelineFromJSON(jsonValue));
  }

  /**
   * Finds a specific pipeline by ID.
   */
  async getPipeline(
    id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiPipeline> {
    const response = await this.getPipelineRaw({ id: id }, initOverrides);
    return await response.value();
  }

  /**
   * Returns a YAML template that contains the specified pipeline version\'s description, parameters and metadata.
   */
  async getPipelineVersionTemplateRaw(
    requestParameters: GetPipelineVersionTemplateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiGetTemplateResponse>> {
    if (requestParameters['version_id'] == null) {
      throw new runtime.RequiredError(
        'version_id',
        'Required parameter "version_id" was null or undefined when calling getPipelineVersionTemplate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/pipeline_versions/{version_id}/templates`;
    urlPath = urlPath.replace(
      `{${'version_id'}}`,
      encodeURIComponent(String(requestParameters['version_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGetTemplateResponseFromJSON(jsonValue),
    );
  }

  /**
   * Returns a YAML template that contains the specified pipeline version\'s description, parameters and metadata.
   */
  async getPipelineVersionTemplate(
    version_id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiGetTemplateResponse> {
    const response = await this.getPipelineVersionTemplateRaw(
      { version_id: version_id },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Gets a pipeline version by pipeline version ID.
   */
  async getPipelineVersionRaw(
    requestParameters: GetPipelineVersionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiPipelineVersion>> {
    if (requestParameters['version_id'] == null) {
      throw new runtime.RequiredError(
        'version_id',
        'Required parameter "version_id" was null or undefined when calling getPipelineVersion().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/pipeline_versions/{version_id}`;
    urlPath = urlPath.replace(
      `{${'version_id'}}`,
      encodeURIComponent(String(requestParameters['version_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiPipelineVersionFromJSON(jsonValue),
    );
  }

  /**
   * Gets a pipeline version by pipeline version ID.
   */
  async getPipelineVersion(
    version_id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiPipelineVersion> {
    const response = await this.getPipelineVersionRaw({ version_id: version_id }, initOverrides);
    return await response.value();
  }

  /**
   * Returns a single YAML template that contains the description, parameters, and metadata associated with the pipeline provided.
   */
  async getTemplateRaw(
    requestParameters: GetTemplateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiGetTemplateResponse>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling getTemplate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/pipelines/{id}/templates`;
    urlPath = urlPath.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id'])));

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGetTemplateResponseFromJSON(jsonValue),
    );
  }

  /**
   * Returns a single YAML template that contains the description, parameters, and metadata associated with the pipeline provided.
   */
  async getTemplate(
    id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiGetTemplateResponse> {
    const response = await this.getTemplateRaw({ id: id }, initOverrides);
    return await response.value();
  }

  /**
   * Lists all pipeline versions of a given pipeline.
   */
  async listPipelineVersionsRaw(
    requestParameters: ListPipelineVersionsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiListPipelineVersionsResponse>> {
    const queryParameters: any = {};

    if (requestParameters['resource_key_type'] != null) {
      queryParameters['resource_key.type'] = requestParameters['resource_key_type'];
    }

    if (requestParameters['resource_key_id'] != null) {
      queryParameters['resource_key.id'] = requestParameters['resource_key_id'];
    }

    if (requestParameters['page_size'] != null) {
      queryParameters['page_size'] = requestParameters['page_size'];
    }

    if (requestParameters['page_token'] != null) {
      queryParameters['page_token'] = requestParameters['page_token'];
    }

    if (requestParameters['sort_by'] != null) {
      queryParameters['sort_by'] = requestParameters['sort_by'];
    }

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/pipeline_versions`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiListPipelineVersionsResponseFromJSON(jsonValue),
    );
  }

  /**
   * Lists all pipeline versions of a given pipeline.
   */
  async listPipelineVersions(
    resource_key_type?: ListPipelineVersionsV1ResourceKeyTypeEnum,
    resource_key_id?: string,
    page_size?: number,
    page_token?: string,
    sort_by?: string,
    filter?: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiListPipelineVersionsResponse> {
    const response = await this.listPipelineVersionsRaw(
      {
        resource_key_type: resource_key_type,
        resource_key_id: resource_key_id,
        page_size: page_size,
        page_token: page_token,
        sort_by: sort_by,
        filter: filter,
      },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Finds all pipelines.
   */
  async listPipelinesRaw(
    requestParameters: ListPipelinesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiListPipelinesResponse>> {
    const queryParameters: any = {};

    if (requestParameters['page_token'] != null) {
      queryParameters['page_token'] = requestParameters['page_token'];
    }

    if (requestParameters['page_size'] != null) {
      queryParameters['page_size'] = requestParameters['page_size'];
    }

    if (requestParameters['sort_by'] != null) {
      queryParameters['sort_by'] = requestParameters['sort_by'];
    }

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    if (requestParameters['resource_reference_key_type'] != null) {
      queryParameters['resource_reference_key.type'] =
        requestParameters['resource_reference_key_type'];
    }

    if (requestParameters['resource_reference_key_id'] != null) {
      queryParameters['resource_reference_key.id'] = requestParameters['resource_reference_key_id'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/pipelines`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiListPipelinesResponseFromJSON(jsonValue),
    );
  }

  /**
   * Finds all pipelines.
   */
  async listPipelines(
    page_token?: string,
    page_size?: number,
    sort_by?: string,
    filter?: string,
    resource_reference_key_type?: ListPipelinesV1ResourceReferenceKeyTypeEnum,
    resource_reference_key_id?: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiListPipelinesResponse> {
    const response = await this.listPipelinesRaw(
      {
        page_token: page_token,
        page_size: page_size,
        sort_by: sort_by,
        filter: filter,
        resource_reference_key_type: resource_reference_key_type,
        resource_reference_key_id: resource_reference_key_id,
      },
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Update the default pipeline version of a specific pipeline.
   */
  async updatePipelineDefaultVersionRaw(
    requestParameters: UpdatePipelineDefaultVersionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['pipeline_id'] == null) {
      throw new runtime.RequiredError(
        'pipeline_id',
        'Required parameter "pipeline_id" was null or undefined when calling updatePipelineDefaultVersion().',
      );
    }

    if (requestParameters['version_id'] == null) {
      throw new runtime.RequiredError(
        'version_id',
        'Required parameter "version_id" was null or undefined when calling updatePipelineDefaultVersion().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/pipelines/{pipeline_id}/default_version/{version_id}`;
    urlPath = urlPath.replace(
      `{${'pipeline_id'}}`,
      encodeURIComponent(String(requestParameters['pipeline_id'])),
    );
    urlPath = urlPath.replace(
      `{${'version_id'}}`,
      encodeURIComponent(String(requestParameters['version_id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Update the default pipeline version of a specific pipeline.
   */
  async updatePipelineDefaultVersion(
    pipeline_id: string,
    version_id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.updatePipelineDefaultVersionRaw(
      { pipeline_id: pipeline_id, version_id: version_id },
      initOverrides,
    );
    return await response.value();
  }
}

/**
 * @export
 */
export const ListPipelineVersionsV1ResourceKeyTypeEnum = {
  UNKNOWN_RESOURCE_TYPE: 'UNKNOWN_RESOURCE_TYPE',
  EXPERIMENT: 'EXPERIMENT',
  JOB: 'JOB',
  PIPELINE: 'PIPELINE',
  PIPELINE_VERSION: 'PIPELINE_VERSION',
  NAMESPACE: 'NAMESPACE',
} as const;
export type ListPipelineVersionsV1ResourceKeyTypeEnum =
  (typeof ListPipelineVersionsV1ResourceKeyTypeEnum)[keyof typeof ListPipelineVersionsV1ResourceKeyTypeEnum];
/**
 * @export
 */
export const ListPipelinesV1ResourceReferenceKeyTypeEnum = {
  UNKNOWN_RESOURCE_TYPE: 'UNKNOWN_RESOURCE_TYPE',
  EXPERIMENT: 'EXPERIMENT',
  JOB: 'JOB',
  PIPELINE: 'PIPELINE',
  PIPELINE_VERSION: 'PIPELINE_VERSION',
  NAMESPACE: 'NAMESPACE',
} as const;
export type ListPipelinesV1ResourceReferenceKeyTypeEnum =
  (typeof ListPipelinesV1ResourceReferenceKeyTypeEnum)[keyof typeof ListPipelinesV1ResourceReferenceKeyTypeEnum];
